import React, { ReactNode, useEffect, useState } from "react";
import {
  AppBar,
  Box,
  Container,
  CssBaseline,
  Drawer,
  IconButton,
  Paper,
  Toolbar,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Outlet } from "react-router";
import DttFooter from "@/components/DttFooter";
import EducatorRegisterHeader from "@/components/EducatorRegisterHeader";
import TCCDeadlineBanner from "@/components/TCCDeadlineBanner";
const TCCScoringSystemLayout = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("md"))

  const [sidebarOpen, setSidebarOpen] = useState(!isMobile)

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  useEffect(() => {
    setSidebarOpen(!isMobile)
  }, [isMobile])
  return (
    <>
      {/* <CustomBreadcrumbProvider> */}
        {/* <Container maxWidth="xl"> */}
        <Box
          sx={{
            // backgroundColor: "#f0f7ff",
            backgroundColor: "#f8fafc",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <CssBaseline />
          <EducatorRegisterHeader />
          <TCCDeadlineBanner />
          <Box display="flex" minHeight="100vh" flexDirection="column">
            {/* <AdminHeader /> */}
            <Box
              sx={{
                display: "flex",
                flex: 1,
                borderTop: "1px solid #ddd",
                // marginTop: "1.5rem",
              }}
            >
              <Box
                component="main"
                sx={{
                  flex: 1,
                  overflow: "hidden",
                  // p: { xs: 1, md: 3 },
                }}
              >
                <Paper
                  sx={{
                    // mb: 2,
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    position: "relative",
                    background: "unset",
                    boxShadow: "unset",
                  }}
                >
                  <Outlet />
                </Paper>
              </Box>
            </Box>
          </Box>
          <DttFooter />
        </Box>
      {/* </CustomBreadcrumbProvider> */}
      {/* </Container> */}
    </>
  );
};

export default TCCScoringSystemLayout;